/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AdditionalResourceDetailsForFinopsBudgetSystem extends models.AdditionalResourceDetailsBase {
    constructor() {
        super();
        this.setDiscriminator("AdditionalResourceDetailsForFinopsBudgetSystem");
    }

    getFixupPrototypeFunction() { return AdditionalResourceDetailsForFinopsBudgetSystem.fixupPrototype; }

    static newInstance(model: Partial<AdditionalResourceDetailsForFinopsBudgetSystem>): AdditionalResourceDetailsForFinopsBudgetSystem {
        let obj = Object.assign(new AdditionalResourceDetailsForFinopsBudgetSystem(), model);
        AdditionalResourceDetailsForFinopsBudgetSystem.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AdditionalResourceDetailsForFinopsBudgetSystem>): AdditionalResourceDetailsForFinopsBudgetSystem {
        if (!model) return null;
        return AdditionalResourceDetailsForFinopsBudgetSystem.newInstance(<AdditionalResourceDetailsForFinopsBudgetSystem> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AdditionalResourceDetailsForFinopsBudgetSystem) {
        if (!obj) return;

        models.AdditionalResourceDetailsForFinopsBudgetSystem.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AdditionalResourceDetailsForFinopsBudgetSystem): boolean {
        if (models.AdditionalResourceDetailsBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AdditionalResourceDetailsForFinopsBudgetSystem.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.actual_cost === undefined) {
            this.actual_cost = 0;
        }
        if (this.forecast_cost === undefined) {
            this.forecast_cost = 0;
        }
        if (this.budget_cost === undefined) {
            this.budget_cost = 0;
        }
        if (this.percentage === undefined) {
            this.percentage = 0;
        }
    }

    /**
     * Resource Id
     */
    resource_id: string;

    /**
     * Actual Cost
     */
    actual_cost: number;

    /**
     * ForeCast Cost
     */
    forecast_cost: number;

    /**
     * Budget Cost
     */
    budget_cost: number;

    /**
     * budget scope
     */
    scope: string;

    /**
     * type of the budget
     */
    budget_type: string;

    /**
     * Percentage diff
     */
    percentage: number;

}
